package core.constants

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 12.03.20
 * Author : leonhergt
 */
object TextKeys {
    // ----------------------------------------------------------------------------
    // Constants
    // ----------------------------------------------------------------------------
    const val TEAM_NAME="Science City Jena"
    const val BO_TITLE_DASHBOARD = "Dashboard"
    const val BO_TITLE_TEAMLOGOS = "Teamlogos"
    const val BO_TITLE_PLAYERDATA = "Spielerdaten"
    const val BO_TITLE_ADPARTNER = "Werbepartner"
    const val BO_TITLE_TRAINING = "Trainingszeiten"
    const val BO_TITLE_SERVER = "Server neustarten"
    const val BO_TITLE_LIVETICKER = "Liveticker mocken"
    const val BO_TITLE_SEASON = "Saisonwechsel"
    const val BO_TITLE_PLAYOFFS = "Playoffs Einstellungen"
    const val BO_TITLE_GAMES = "Spiele"
    const val BO_TITLE_LIGHTSHOW = "Lichtshows"

    const val BO_ICON_ARROW_BACK = "arrow_back"
    const val BO_ICON_ADD = "add"
    const val BO_ICON_DATATABLE = "view_list"
    const val BO_ICON_ERROR = "error_outline"
    const val BO_ICON_CHECKED = "done"
    const val BO_ICON_EDIT = "edit"
    const val BO_ICON_DELETE = "delete"
    const val BO_ICON_SAVE = "save"
    const val BO_ICON_UPLOAD = "cloud_upload"
    const val BO_ICON_WARNING = "warning"
    const val BO_ICON_CLOSE = "close"
    const val BO_ICON_SERVER = "storage"
    const val BO_ICON_LIVETICKER = "settings_input_antenna"
    const val BO_ICON_SEASON = "published_with_changes"
    const val BO_ICON_ADPARTNER = "next_week"
    const val BO_ICON_PLAYERDATA = "how_to_reg"
    const val BO_ICON_TEAMLOGOS = "add_photo_alternate"
    const val BO_ICON_TRAINING = "access_time"
    const val BO_ICON_IMAGE_CROSSEDOUT = "image_not_supported"
    const val BO_ICON_BASKETBALL = "sports_basketball"
    const val BO_ICON_LIGHTSHOW = "bolt"

    const val BO_DROPDOWN_IMAGE = "IMAGE"
    const val BO_DROPDOWN_IMAGE_TEXT = "IMAGE_AND_TEXT"
    const val BO_DROPDOWN_GIF = "GIF"
    const val BO_DROPDOWN_GAME_LIKE = "GAME_LIKE"

    const val BO_PLAYOFFS_IMAGE = "IMAGE"
    const val BO_PLAYOFFS_URL = "URL"

    const val BO_TOPIC_NEWS = "news_v4"
    const val BO_TOPIC_QUARTER = "quarterTime"
    const val BO_TOPIC_HALF = "halfTime"
    const val BO_NAME_NEWS = "News"
    const val BO_NAME_GAMERESULT = "Spielergebnisse"
    const val BO_NAME_QUARTER = "Viertelstände"
    const val BO_NAME_HALF = "Halbzeitstände"

    const val BO_PUSH_CONTEXT = "context"
    const val BO_OnclickPushToSocialMedia = "onNewSocialMedia"
    const val BO_OnclickPushToNews = "onNewNews"
    const val BO_OnclickPushToGameResult = "onNewGameResults"

    const val SCHEDULE_SCROLL_ID = "scheduleScrollId"

    // ----------------------------------------------------------------------------
    // Public properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Init
    // ----------------------------------------------------------------------------
    init {

    }

    // ----------------------------------------------------------------------------
    // Constructor
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // System/Overridden methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Interfaces/Listener
    // ----------------------------------------------------------------------------

}